import classnames from 'classnames';
import React from 'react';

import styles from './icon.module.scss';
import { Props } from './types';

const Icon: React.FC<Props> = ({ alt, icon, className, ...props }) => (
  <img
    className={classnames(styles.base, className)}
    src={`https://static.policygenius.com/svgs/${icon}.svgz`}
    alt={alt ?? ''}
    title={icon}
    {...props}
  />
);

export default Icon;
